import cloneDeep from 'lodash/cloneDeep';
import { DateTime } from 'luxon';
import {
  OrderTypes,
  ProcessStep,
  ProcessStepSubCategories,
} from '../common/enums/enums';
import i18n from '../translations/i18n';
import { fromDBToLocalTimestamp } from './date';

export const activityLogDataProcess = data => {
  const activityLog = (data.relatedOrders || []).reduce((acc, ro) => {
    const orderTypeTranslate = `${i18n.t(
      `workOrdersTable:vehicleTable.activityLog.orderType.${ro.orderType}`
    )}`;
    const categoryType = `${i18n.t(
      `workOrdersTable:detail.orderTag.${ro.orderCategoryType}`
    )}`;

    const roActivity = (ro.workflowHistory || [])
      .filter(
        e =>
          e.step === ProcessStep.DONE ||
          ProcessStep.IN_PROCESS ||
          ProcessStep.APPROVED ||
          ProcessStep.DECLINED ||
          ProcessStep.PAUSED ||
          ProcessStep.CANCELED
      )
      .reduce((accumulator, wh) => {
        if (
          ro.orderType === OrderTypes.RECONDITIONING &&
          wh.step === ProcessStep.APPROVED
        )
          return accumulator;
        const stepState = step => {
          if (step === ProcessStep.IN_PROCESS)
            return i18n.t('workOrderStepper:workOrderSteps.inProcess');
          if (step === ProcessStep.PAUSED)
            return i18n.t('workOrderStepper:workOrderSteps.paused');
          return i18n.t(
            `workOrderStepper:workOrderSteps.${step.toLowerCase()}`
          );
        };

        accumulator.push({
          title: `${
            ro.orderType === OrderTypes.RECONDITIONING ? '' : orderTypeTranslate
          } ${stepState(wh.step)} • ${categoryType}`,
          date: wh.createdAt,
          name: [wh.person.firstName, wh.person.lastName]
            .filter(x => x)
            .join(' '),
        });
        return accumulator;
      }, []);

    acc.push(...roActivity);
    return acc.sort((a, b) => new Date(b.date) - new Date(a.date));
  }, []);

  const dateFormat = activityLog.map(al => ({
    ...al,
    date: fromDBToLocalTimestamp(al.date, DateTime.DATETIME_SHORT),
  }));

  dateFormat.push({
    title: `${i18n.t(
      `workOrdersTable:vehicleTable.activityLog.orderType.inspection`
    )} • ${data?.package?.packageName}`,
    date: fromDBToLocalTimestamp(data.dateOrdered, DateTime.DATETIME_SHORT),
    name: [data?.requester?.firstName, data?.requester?.lastName]
      .filter(x => x)
      .join(' '),
  });
  return dateFormat;
};

export const stepsModifier = data => {
  let prevStep;
  const arr = cloneDeep(data);
  const modifiedArray = arr.map((d, i) => {
    prevStep = data[i - 1]?.step;
    if (d.step === ProcessStep.PAUSED)
      d.step = ProcessStepSubCategories.IN_TRANSIT_PAUSED;
    if (d.step === ProcessStep.IN_PROCESS && prevStep === ProcessStep.DONE) {
      d.step = ProcessStepSubCategories.RESTORED_IN_PROCESS;
    }
    return d;
  });
  return modifiedArray.reverse();
};
